module.exports = __webpack_public_path__ + "img/cmj-jumping-profile.81eed242.svg";